import styled from "@emotion/styled";

export const ImageHeroWrapper = styled.div`
  position: relative;
  height: 100vh;
  z-index: 2000;

}
`


export const HeroImage = styled.div`
  opacity: 1;

  .gatsby-image-wrapper{
    height: 100vh;
  }

  .tl-edges > div:nth-last-of-type(2) & {
    opacity: 0;
  }
`;

export const HeroText = styled.div`

  position: absolute;
  z-index: 20;
  color: #fff;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);

  h5{
    margin: 0;
    transition: opacity 2000ms;
    opacity: 1;
  }
  h2{
    margin: 2vw 0;
    white-space: pre-line;
  }

  .tl-wrapper-status--entering &{
  }

  .tl-edges > div:nth-last-of-type(2) & {
    h2, h5{
    transition: opacity 0ms;
    opacity: 0;
    }
  }
`
